export default __webpack_public_path__ + "static/media/Talons of the Cackling Marionette.211325af.jpg";